/**
 * 404 页面
 */

import { Button, Result, Space } from 'antd';
import { useLocation, useNavigate } from 'react-router-dom';

export default function NotFound(): React.ReactElement {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <Result
      status="404"
      title="页面不存在"
      subTitle={
        <Space direction="vertical" size={2}>
          <span>未找到路径 {location.pathname} 对应的页面。</span>
          <span style={{ fontSize: 12, color: 'rgba(0,0,0,0.45)' }}>
            可能是链接已失效，或该功能未对当前角色开放（无权限的菜单不会出现在左侧导航中）。
          </span>
        </Space>
      }
      extra={
        <Space>
          <Button type="primary" onClick={() => navigate('/dashboard')}>
            返回工作台
          </Button>
          <Button onClick={() => navigate(-1)}>返回上一页</Button>
        </Space>
      }
    />
  );
}
